<!--
     <ActionContacts
       :unit="QUnit"
     />
-->

<template>
  <v-menu
    v-if="show_action"
    dense
    top
    offset-y
    content-class="qmkey-explorer-table-menu-contents"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        :color="color"
        v-bind="attrs"
        v-on="on"
        :small="size == 'small'"
        :large="size == 'large'"
        @click="click"
        >
        mdi-at
      </v-icon>
    </template>

    <v-list dense class="overflow-y-auto" two-line>
      <v-list-item
        v-for="contact in unit.contacts"
        :key="contact.value"
      >
        <v-list-item-avatar color="primary" :size="32">
          <v-img 
            v-if="contact.photo"
            :src="contact.photo">
          </v-img>
          <span
            v-else
            color="primary"
          >
            {{ contact.initials }}
          </span>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="contact.title"></v-list-item-title>
          <v-list-item-subtitle v-text="contact.role"></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon
            small
            @click="copyToClipboard(contact.phone)"
            :color="color"
          >
            mdi-file-phone-outline
          </v-icon>
        </v-list-item-action>
        <v-list-item-action>
          <v-icon 
            small
            @click="copyToClipboard(contact.email)"
            :color="color"
          >
            mdi-email-outline
          </v-icon>
        </v-list-item-action>              
      </v-list-item>
    </v-list>
  </v-menu>
</template>


<script>
 export default {
   name: "ActionContacts",

   props: {
     unit: {required: true},
     size: {default: 'small'},
     color: {},
   },

   computed: {
      show_action() {
        return this.unit.contacts && (this.unit.contacts || []).length > 0;
      },
   },

   methods: {
     copyToClipboard(textToCopy)  {
       navigator.clipboard.writeText(textToCopy);
     },
     click() {
      this.$emit('clicked');
     }
   },
 };
</script>
